const validateNumber = /^[1-9][0-9]*$/;

export default validateNumber;
